import { cx } from '@linaria/core';
import { units } from '@ui/css';
import { tokens, ssrContainer } from './show-for.style.js';
import { jsx } from 'react/jsx-runtime';
import { useMatchMedia } from '../hooks/match-media.js';

function ShowFor(props) {
  const matches = useMatchMedia(props.breakpoint.toQuery(), {
    immediate: props.immediate
  });
  switch (matches) {
    case true:
      return /*#__PURE__*/jsx("div", {
        "data-show-for": false,
        className: props.className,
        children: props.children
      });
    case false:
      return null;
    default:
      return /*#__PURE__*/jsx("div", {
        "data-show-for": true,
        className: cx(ssrContainer, props.className),
        style: tokens.__override({
          from: units.px(props.breakpoint.from ?? 0),
          to: units.px(props.breakpoint.to ?? 100000)
        }),
        children: props.children
      });
  }
}

export { ShowFor };
//# sourceMappingURL=show-for.js.map
